import { render, staticRenderFns } from "./FaqNewIntent.vue?vue&type=template&id=5dbb7c42&scoped=true&"
import script from "./FaqNewIntent.vue?vue&type=script&lang=js&"
export * from "./FaqNewIntent.vue?vue&type=script&lang=js&"
import style0 from "./FaqNewIntent.vue?vue&type=style&index=0&id=5dbb7c42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb7c42",
  null
  
)

export default component.exports